import withStyles from '@mui/styles/withStyles';

import Typography from '@classify/react-core-components/Typography';

export const styles = /* istanbul ignore next */ ({ palette, spacing }) => ({
  root: {
    textAlign: 'center',
  },
  decorationContainer: {
    margin: spacing(2, 0),
  },
  title: {
    color: palette.text.onMainSecondary,
    marginBottom: spacing(1),
  },
  content: {},
});

export const PromoContent = ({
  classes = {},
  title,
  content,
  decoration = null,
  titleProps = {},
}) => (
  <div className={classes.root}>
    {decoration && <div className={classes.decorationContainer}>{decoration}</div>}
    <Typography className={classes.title} variant="h5" {...titleProps}>
      {title}
    </Typography>
    <Typography className={classes.content} variant="body">
      {content}
    </Typography>
  </div>
);

export default withStyles(styles)(PromoContent);
